import { TopDays } from '../../../models/analytics/analytics.model';
import { useGet } from '../../useApi';

// GET /admin/analytics/users/top-days?from&to
const useTopDays = () => {
  const { data, loading, fetch } = useGet<TopDays>('Failed to load top days');
  return { topDays: data, loading, fetchTopDays: (from: string, to: string) => fetch('api/v1/admin/analytics/users/top-days', { from, to }) };
};

export default useTopDays;
